module.exports = __webpack_public_path__ + "media/images/courses/bg-carousel-76d5dd751a976c0a014aba9a4c3376d2.jpeg";